import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import isEqual from 'react-fast-compare';
import keyBy from 'lodash/keyBy';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import ErrorBoundary from '../../ErrorBoundary';
import { useTorpedoLayout } from './hooks/useTorpedoLayout';
import { didItemsChange } from './helpers';
import TorpedoRow from './_partials/TorpedoRow';
import s from './BaseTorpedo.scss';
var BaseTorpedo = function (props) {
    var innerRef = props.innerRef, _a = props.items, items = _a === void 0 ? [] : _a, container = props.container, layoutConfig = props.layoutConfig, useCardLayout = props.useCardLayout, maxRows = props.maxRows, hideIncompleteRows = props.hideIncompleteRows, enableScrollVisibilityOptimisation = props.enableScrollVisibilityOptimisation, contentStrip = props.contentStrip, _b = props.contentStripOffset, contentStripOffset = _b === void 0 ? 0 : _b, renderItem = props.renderItem, onOffsetReached = props.onOffsetReached, testRenderSpy = props.testRenderSpy, testRecalculateLayoutSpy = props.testRecalculateLayoutSpy;
    var _c = useTorpedoLayout({
        items: items,
        container: container,
        layoutConfig: layoutConfig,
        useCardLayout: useCardLayout,
        maxRows: maxRows,
        hideIncompleteRows: hideIncompleteRows,
        testRecalculateLayoutSpy: testRecalculateLayoutSpy,
    }), rows = _c.rows, styleParams = _c.styleParams;
    useDebugRerenders('BaseTorpedo', __assign(__assign({}, props), { rows: rows, styleParams: styleParams }));
    var dataItemDictionary = useMemo(function () { return keyBy(items, function (item) { return item.id; }); }, [items]);
    if (!(rows === null || rows === void 0 ? void 0 : rows.length)) {
        return (React.createElement(ErrorBoundary, { debugComponent: "BaseTorpedo" },
            React.createElement("div", { className: s['root'], ref: innerRef })));
    }
    // Remove the outer gutter, this works by root having
    // overflow:hidden and width set to container.width
    var wrapMargins = {
        marginLeft: "-".concat(styleParams.itemSpacing, "px"),
        marginTop: "-".concat(styleParams.itemSpacing, "px"),
        marginBottom: "-".concat(styleParams.itemSpacing, "px"),
    };
    testRenderSpy && testRenderSpy();
    return (React.createElement(ErrorBoundary, { debugComponent: "BaseTorpedo" },
        React.createElement("div", { className: s['root'], ref: innerRef, style: { width: container.width } },
            React.createElement("div", { style: wrapMargins }, rows.map(function (row) {
                var _a;
                return (React.createElement(TorpedoRow, { key: row.idx, idx: row.idx, width: row.width, height: row.height + ((_a = row.extraItemHeight) !== null && _a !== void 0 ? _a : 0), layoutItems: row.items, dataItems: dataItemDictionary, contentStrip: row.idx === contentStripOffset + 1 && contentStrip, scrollOptims: enableScrollVisibilityOptimisation, onOffsetReached: onOffsetReached, renderItem: renderItem }));
            })))));
};
BaseTorpedo.displayName = 'BaseTorpedo';
export default React.memo(BaseTorpedo, function (_a, _b) {
    var prevItems = _a.items, prevProps = __rest(_a, ["items"]);
    var nextItems = _b.items, nextProps = __rest(_b, ["items"]);
    if (didItemsChange(prevItems, nextItems)) {
        return false;
    }
    return isEqual(prevProps, nextProps);
});
//# sourceMappingURL=BaseTorpedo.js.map